import {
  GET_ALERTS,
  GET_ALERTS_INIT,
  GET_ALERTS_SUCCESS,
  GET_ALERTS_FAILED,
  GET_UNSEEN_MESSAGES_INIT,
  GET_UNSEEN_MESSAGES_SUCCESS,
  GET_UNSEEN_MESSAGES_FAILED,
  GET_UNSEEN_MESSAGES,
} from "./constants";
import { getUtil } from "../../../services/axiosClient";
import { API } from "../../../utils/Constant";
// import jwt_decode from "jwt-decode";
import { put, takeLatest } from "redux-saga/effects";

export function* getAlerts({ payload }) {
  try {
    yield put({ type: GET_ALERTS_INIT });
    const res = yield getUtil(`${API.GetAlerts}?Page=0&PerPage=10`, null);
    if (res?.status === 200) {
      const { data } = res;

      yield put({
        type: GET_ALERTS_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: GET_ALERTS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* getUnSeenMessages({ payload }) {
  try {
    yield put({ type: GET_UNSEEN_MESSAGES_INIT });
    const res = yield getUtil(
      `${API.GetUnSeenMessages}?UserId=${payload}`,
      null,
      window._env_.CHAT_API_URL
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: GET_UNSEEN_MESSAGES_SUCCESS,
        payload: data ,
      });
    } else {
      yield put({ type: GET_UNSEEN_MESSAGES_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* AlertActions() {
  yield takeLatest(GET_ALERTS, getAlerts);
  yield takeLatest(GET_UNSEEN_MESSAGES, getUnSeenMessages);

}
